const initialState = [];

const forms = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_ALL_ACTIONS":
      state = action.forms || [];
      return state;
    default:
      return state;
  }
};

export default forms;
